/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class LinkedInOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a LinkedIn Person or Company Page"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your LinkedIn accounts to dlvr.it</p>
                    )}
                    typeLabel="LinkedIn account"/>
            </div>
        );
    }
}

LinkedInOutput.displayName = "LinkedInOutput";

export default LinkedInOutput;
